import { post } from '../../../services/api';
import { HandoverItemResponse } from '../types/api-contracts/handoverItemResponse';
import { HandoverItem } from '../types/domain/handoverItem';
import { toDomainHandoverItem } from './mappers/toDomainHandoverItem';

export const consolidateHandovers = async (): Promise<HandoverItem[]> => {
  const response = await post<HandoverItemResponse[]>('/api/v1/handover-support/consolidate', null);
  return response.map(toDomainHandoverItem);
};
